<div class="footer">
    <div class="footer-container">
        <div class="row footer-links">
            <div class="col-md-4 col-sm-12">
                <p>WORDIIX</p>
                <div class="title-divider"></div>
                <ul>
                    <li><a href="https://wordiix.com/blog/"><i aria-hidden="true" class="far fa-newspaper"></i> Blog</a>
                    </li>
                    <li><a href="https://wordiix.com/plan-premium/"><i aria-hidden="true" class="far fa-star"></i>Plan
                            Premium</a></li>
                </ul>
            </div>
            <div class="col-md-4 col-sm-12">
                <p>LEGAL</p>
                <div class="title-divider"></div>
                <ul>
                    <li><a href="https://wordiix.com/aviso-legal/">Aviso legal</a></li>
                    <li><a href="https://wordiix.com/politica-de-cookies/">Política de cookies</a></li>
                    <li><a href="https://wordiix.com/politica-privacidad/">Política de privacidad</a></li>
                </ul>
            </div>
            <div class="col-md-4 col-sm-12">
                <p>CONTACTO</p>
                <div class="title-divider"></div>
                <ul>
                    <li><a href="mailto:soporte@wordiix.com" target="_blank">
                            <i aria-hidden="true" class="far fa-envelope"></i>soporte@wordiix.com
                        </a>
                    </li>
                </ul>
                <div class="footer-rrss">
                    <div>
                        <a href="https://twitter.com/wordiixapp" target="_blank" class="social-icon-box twitter">
                            <i class="fab fa-twitter social-icon"></i>
                        </a>
                        <a href="https://www.facebook.com/Wordiix-103555822070142" target="_blank"
                            class="social-icon-box facebook">
                            <i class="fab fa-facebook social-icon"></i>
                        </a>
                        <a href="https://www.instagram.com/wordiixapp/" target="_blank"
                            class="social-icon-box instagram">
                            <i class="fab fa-instagram social-icon"></i>
                        </a>
                        <a href="https://www.linkedin.com/company/wordiix" target="_blank"
                            class="social-icon-box linkedin">
                            <i class="fab fa-linkedin social-icon"></i>
                        </a>
                    </div>

                </div>
            </div>
        </div>



    </div>
    <div class="footer-bottom">
        <div class="footer-divider"></div>

        <div class="footer-logo">
            <img src="assets/img/logo.svg" class="header-img" />
        </div>
    </div>
</div>